/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GenresGetResponse } from '../models/GenresGetResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class GenresService {
    /**
     * @param searchString
     * @param skip
     * @param take
     * @returns GenresGetResponse OK
     * @throws ApiError
     */
    public static get(
        searchString?: string,
        skip?: any,
        take?: any,
    ): CancelablePromise<GenresGetResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Genres',
            query: {
                'searchString': searchString,
                'skip': skip,
                'take': take,
            },
        });
    }
}
